"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GOOGLE_API_LIBRARIES = exports.ANGEL_DE_LA_INDEPENDENCIA = void 0;
var GOOGLE_API_LIBRARIES = exports.GOOGLE_API_LIBRARIES = ['places'];
var ANGEL_DE_LA_INDEPENDENCIA = exports.ANGEL_DE_LA_INDEPENDENCIA = {
  lat: 19.4270245,
  lng: -99.16766469999999
};